(() => {
  function norm(s) { return String(s == null ? "" : s).trim().toLowerCase(); }

  function initCard(card) {
    const picker = card.querySelector('.fp-variants');
    const priceEl = card.querySelector('[data-fp="price"]');
    const compareEl = card.querySelector('[data-fp="compare"]');
    const badgeEl = card.querySelector('[data-fp="badge"]');
    const atcBtn = card.querySelector('[data-fp="atc"]');

    // Read embedded JSON
    let variants = [], priceMap = {};
    try {
      const vEl = card.querySelector('.fp-product-variants');
      const mEl = card.querySelector('.fp-variant-price-map');
      variants = JSON.parse(vEl ? vEl.textContent : '[]') || [];
      priceMap = JSON.parse(mEl ? mEl.textContent : '{}') || {};
    } catch (e) { variants = []; priceMap = {}; }

    function selectedValues() {
      const vals = [];
      (picker || card).querySelectorAll('.fp-option').forEach(fs => {
        const c = fs.querySelector('input[type="radio"]:checked');
        if (c) vals.push(String(c.value));
      });
      return vals;
    }

    function findVariant(sel) {
      const byOpts = variants.find(v => {
        if (!v) return false;
        const opts = [];
        if ('option1' in v) opts.push(String(v.option1));
        if ('option2' in v && v.option2 != null) opts.push(String(v.option2));
        if ('option3' in v && v.option3 != null) opts.push(String(v.option3));
        if (opts.length !== sel.length) return false;
        for (let i = 0; i < sel.length; i++) { if (norm(opts[i]) !== norm(sel[i])) return false; }
        return true;
      });
      if (byOpts) return byOpts;
      const key = norm(sel.join(' / '));
      return variants.find(v => norm(v?.title) === key) || null;
    }

    function applyVariant(v) {
      const m = priceMap[String(v.id)];
      if (!m) return;

      if (priceEl) priceEl.textContent = m.price_formatted || '';
      const hasDisc = m.compare_at_price && (m.compare_at_price > m.price);

      if (compareEl) {
        compareEl.textContent = m.compare_formatted || '';
        compareEl.hidden = !hasDisc;
      }
      if (badgeEl) {
        if (hasDisc) {
          const pct = Math.round(((m.compare_at_price - m.price) * 100) / m.compare_at_price);
          badgeEl.textContent = `-${pct}%`;
          badgeEl.hidden = (pct <= 0);
        } else {
          badgeEl.hidden = true;
        }
      }
      // Update all links in this card to selected variant
      const murl = m.url;
      if (murl) {
        card.querySelectorAll('a[href]').forEach(a => a.setAttribute('href', murl));
      }
      // ATC state
      if (atcBtn) {
        atcBtn.dataset.variantId = String(v.id);
        atcBtn.disabled = !m.available;
        atcBtn.title = m.available ? 'Add to cart' : 'Sold out';
      }
    }

    function currentVariant() {
      const sel = selectedValues();
      let v = sel.length ? findVariant(sel) : null;
      if (!v) v = variants.find(x => x && x.available) || variants[0] || null;
      return v;
    }

    function update() { const v = currentVariant(); if (v) applyVariant(v); }

    // Variant changes
    if (picker) {
      picker.addEventListener('change', update);
      picker.addEventListener('input', update);
      picker.addEventListener('click', e => {
        const t = e.target;
        if (t && (t.tagName === 'INPUT' || t.closest('label'))) update();
      });
    }

    // Ajax ATC 
    if (atcBtn) {
      atcBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        const v = currentVariant();
        if (!v || !v.id) return;

        try {
          atcBtn.classList.add('fp-atc--loading');
          atcBtn.disabled = true;

          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: 1 })
          });
          if (!resp.ok) throw new Error('Add to cart failed');
          await resp.json();

          atcBtn.classList.remove('fp-atc--loading');
          atcBtn.classList.add('fp-atc--added');

          // Silent: do NOT open drawer
          document.dispatchEvent(new Event('fp:cart:silent-add'));
          setTimeout(() => {
            atcBtn.classList.remove('fp-atc--added');
            atcBtn.disabled = false;
          }, 1200);
        } catch (err) {
          atcBtn.classList.remove('fp-atc--loading');
          atcBtn.disabled = false;
          // Optional fallback: do nothing (stay silent)
        }
      }, { capture: true });
    }


    // Direct redirect to cart
    // if (atcBtn) {
    //   atcBtn.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    //     const v = currentVariant();
    //     if (!v || !v.id) return;

    //     // Show loader
    //     atcBtn.classList.add('fp-atc--loading');
    //     atcBtn.disabled = true;

    //     // Redirect to cart (Shopify will add the product + go to /cart)
    //     window.location.href = `/cart/add?id=${v.id}&quantity=1`;
    //   }, { capture: true });
    // }



    // Initial paint
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.fp-card').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('page:load', () => initAll(document));
})();
